import React, { useState, useEffect } from 'react'
import { Chart } from '@scuf/charts'
import baseServices from '../../../services/base.services'

const UtilizacionHome = ({ body, height, name }) => {

    const [state, setState] = useState(null)

    // Utilización
    useEffect(() => {
        const getTTeg = async () => {
            try {
                var response = await baseServices.getDataTostacionDMH2(body)
                if (response.data && response.data.length > 0) {
                    let arrayValor1 = []

                    response.data.map((x, i) =>
                        arrayValor1.push(x.Valor)
                    )

                    setState({
                        valor1: parseFloat(arrayValor1)
                    })

                    setTimeout(() => { getTTeg() }, 60000)
                }
            }
            catch (e) {
                console.log(e)
                getTTeg()
            }
        }
        getTTeg()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const fColor = (num) => {
        return num >= 90 ?
            '#28A745'
            : num >= 80 && num < 90 ?
                '#FFC107'
                :
                '#DC3546'
    }

    return (
        <>
            {/* {state && console.log(fColor(state.valor1))} */}
            {
                state ?
                    <>
                        <Chart
                            height={height}
                            colors={[fColor(state.valor1), '#E5E5E5']}
                        >
                            <Chart.Donut
                                data={[
                                    // { name: name, y: state.valor1 },
                                    // { name: name, y: 100 - state.valor1 },
                                    { name: name, y: state.valor1 },
                                    { name: name, y: 100 - state.valor1 },
                                ]}
                            >
                                <Chart.CenterBlock>
                                    <div style={{ marginTop: '0px', paddingTop: '0px', fontWeight: '600' }}>{state.valor1}%</div>
                                </Chart.CenterBlock>
                            </Chart.Donut>
                            <Chart.Legend
                                enabled={false}
                            // name='a'
                            />
                        </Chart>
                        <div style={{ width: '100%', textAlign: 'center' }}><span className='letter'>UTILIZACIÓN</span></div>
                    </>
                    :
                    <div className='letter-origin'>...No hay datos</div>
            }
        </>
    )
}

export default UtilizacionHome